import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { getCustomerServiceList } from '@/api/home'
import StatusPopup from '@/components/common/statusPopup.vue'
import ContactServicePopupOne from '@/themes/themeOne/profile/contactServicePopup.vue'
import ContactServicePopupTwo from '@/themes/themeTwo/profile/contactServicePopup.vue'
import { ref, computed } from 'vue'
import { ContactItem, ContactServiceData } from './supportScript'
import { useThemeStore } from '@/stores/theme'
import ContactService from '@/themes/themeThree/message/contactService.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'contactServicePopup',
  setup(__props, { expose: __expose }) {

const themeStore = useThemeStore()
const show = ref(false)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const serviceList = ref<ContactItem[]>([])

const dataSet = computed<ContactServiceData>(() => ({
    serviceList: serviceList.value,
    show: show.value
}))

const open = () => {
    getServiceList()
}

const close = () => {
    show.value = false
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getServiceList = () => {
    getCustomerServiceList().then(res => {
        serviceList.value = res.data
        show.value = true
    }).catch(err => {
        if (err.code != 401) {
            showError(err)
        }

    })
}

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _directive_modal = _resolveDirective("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createVNode(ContactServicePopupOne, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open
          }, null, 8, ["data-set"]), [
            [_directive_modal, show.value]
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createVNode(ContactServicePopupTwo, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open
          }, null, 8, ["data-set"]), [
            [_directive_modal, show.value]
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createVNode(ContactService, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open
          }, null, 8, ["data-set"]), [
            [_directive_modal, show.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})